export default __webpack_public_path__ + "static/media/packaging.b591d52a.webp";